export const observeFade = () => {
  const fadeItems = document.querySelectorAll('[data-fade]');

  function animateFade(element: Element | null) {
    const [a, b] = ((element as HTMLElement)?.dataset?.fade || '').split('|');
    element?.classList.add('faded');
    a.split(' ').forEach((cls) => {
      if (cls.length > 0) {
        element?.classList.add(cls);
      }
    });
    if (b) {
      b.split(' ').forEach((cls) => {
        if (cls.length > 0) {
          element?.classList.remove(cls);
        }
      });
    }
  }

  const observers: {
    [key: string]: IntersectionObserver;
  } = {};

  fadeItems.forEach((fadeItem) => {
    const dataset = (fadeItem as HTMLElement)?.dataset;
    const [a, b, i] = (dataset?.fade || '').split('|');

    if (i) {
      i.split(' ').forEach((cls) => {
        if (cls.length > 0) {
          fadeItem?.classList.add(cls);
        }
      });
    }
    const threshold = dataset?.fadeThreshold || '0.3';
    setTimeout(() => {
      if (!observers[threshold]) {
        observers[threshold] = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                animateFade(entry.target);
                observer.unobserve(entry.target); // only animate once
              }
            });
          },
          {threshold: Number(threshold)}
        );
      }
      observers[threshold].observe(fadeItem); // observe element
    }, 100);
  });

  return () => {};
};
